var giphy_viewer_default = {
  "giphyWrapper": "Miio4",
  "giphy_player": "t1ND8",
  "playIcon": "bn-zg",
  "gifRatio": "_3adOT"
};
export {
  giphy_viewer_default as default
};
//# sourceMappingURL=giphy-viewer-scss.js.map
